// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubstituteItem_product__i8YCC {
  width: 100%;
}
.SubstituteItem_product__i8YCC p {
  margin: 0;
}
.SubstituteItem_product__i8YCC .SubstituteItem_header__v6d5D {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
  margin-bottom: 4px;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- {
  display: flex;
  justify-content: space-between;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- .SubstituteItem_image__N\\+X-F {
  width: 64px;
  height: 64px;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- .SubstituteItem_properties__ym4c8 {
  display: flex;
  width: 80%;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- .SubstituteItem_properties__ym4c8 img {
  margin-right: 8px;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- .SubstituteItem_properties__ym4c8 .SubstituteItem_name__3O3-Y {
  font-size: 12px;
}
.SubstituteItem_product__i8YCC .SubstituteItem_body__ZilV- .SubstituteItem_properties__ym4c8 .SubstituteItem_property__IiNgJ {
  font-size: 12px;
  color: #616c7a;
}`, "",{"version":3,"sources":["webpack://./src/views/Offers/OfferDetail/SubstituteItem/SubstituteItem.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;AAEE;EACE,SAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eCTK;EDUL,kBAAA;AAAJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AACI;EACE,aAAA;EACA,UAAA;AACN;AAAM;EACE,iBAAA;AAER;AAAM;EACE,eC5BC;AD8BT;AAAM;EACE,eC/BC;EDgCD,cExBA;AF0BR","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.product {\n  width: 100%;\n  p {\n    margin: 0;\n  }\n  .header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    font-size: typography.$body-l;\n    margin-bottom: 4px;\n  }\n  .body {\n    display: flex;\n    justify-content: space-between;\n    .image {\n      width: 64px;\n      height: 64px;\n    }\n    .properties {\n      display: flex;\n      width: 80%;\n      img {\n        margin-right: 8px;\n      }\n      .name {\n        font-size: typography.$body-s;\n      }\n      .property {\n        font-size: typography.$body-s;\n        color: colors.$light;\n      }\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `SubstituteItem_product__i8YCC`,
	"header": `SubstituteItem_header__v6d5D`,
	"body": `SubstituteItem_body__ZilV-`,
	"image": `SubstituteItem_image__N+X-F`,
	"properties": `SubstituteItem_properties__ym4c8`,
	"name": `SubstituteItem_name__3O3-Y`,
	"property": `SubstituteItem_property__IiNgJ`
};
export default ___CSS_LOADER_EXPORT___;
